import { Theme } from '@mui/material';
import { useEffect } from 'react';

import appTheme from '../../theme';

export type UseAppBackgroundParam = (t: Theme) => string | string;

export const useAppBackground = (theme: UseAppBackgroundParam) => {
    useEffect(() => {
        document.body.style.background = theme.call(null, appTheme);
    });
};
